import { render } from "./production.vue?vue&type=template&id=5b6e6fc1&scoped=true"
import script from "./production.vue?vue&type=script&lang=js"
export * from "./production.vue?vue&type=script&lang=js"

import "./production.vue?vue&type=style&index=0&id=5b6e6fc1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6e6fc1"]])

export default __exports__